module.exports = __webpack_public_path__ + "img/tse3.474004db.gif";